import React from 'react';
import './Header.css';

const PUZZLE_TYPE_TITLES = {
  win: 'Win Recognition Puzzle',
  threat: 'Threat Recognition Puzzle',
  passthrough: 'Passthrough Recognition Puzzle',
  denial: 'Denial Recognition Puzzle',
};

const Header = ({ currentPlayer, playerNames = {}, showTutorialHint = false, showCastQuote = false, tutorialStatus, isStackedLayout = false, activePanelIndex = 0, onlineStatus = null, puzzleMetadata = null, puzzleEvalResult = null }) => {
  // Get the display name for the current player
  const getPlayerDisplay = () => {
    if (!currentPlayer) return '—';

    const playerKey = currentPlayer === 1 ? 'p1' : 'p2';
    const playerName = playerNames[playerKey];

    if (playerName && playerName !== 'Human') {
      // Show model name for AI players
      const modelName = playerNames.modelName;
      if (modelName) {
        return `${playerName} (${modelName})`;
      }
      return playerName;
    }

    return `Player ${currentPlayer}`;
  };

  // Determine which tutorial flag to show (mobile board panel only)
  const showFlags = isStackedLayout && activePanelIndex === 1 && tutorialStatus;
  let flagType = null;
  if (showFlags) {
    if (tutorialStatus.stepDone) {
      flagType = 'done';
    } else if (tutorialStatus.needsUndo) {
      flagType = 'undo';
    } else if (tutorialStatus.actionRequired) {
      flagType = 'action';
    }
  }

  return (
    <header className={`header${showCastQuote ? ' header--with-quote' : ''}`}>
      {showTutorialHint && !showFlags && (
        <div className="header__tutorial-hint">
          <span className="header__tutorial-arrow">&larr;</span>
          <span className="header__tutorial-text">tutorial in the left panel</span>
        </div>
      )}
      {showTutorialHint && showFlags && (
        <div className="header__tutorial-row">
          {flagType && (
            <span key={flagType} className={`header__flag header__flag--${flagType}`}>
              {flagType === 'action' ? 'Action Required' : flagType === 'done' ? 'Done' : 'Undo'}
            </span>
          )}
          <div className="header__tutorial-hint header__tutorial-hint--inline">
            <span className="header__tutorial-arrow">&larr;</span>
            <span className="header__tutorial-text">tutorial in left panel</span>
          </div>
        </div>
      )}
      <div className="header__title">
        {puzzleMetadata ? (
          <>
            <span className="header__label">{PUZZLE_TYPE_TITLES[puzzleMetadata.puzzle_type] || 'Puzzle'}</span>
            {puzzleEvalResult ? (
              <span className={`header__puzzle-status header__puzzle-status--${puzzleEvalResult.solved ? 'solved' : 'failed'}`}>
                {puzzleEvalResult.solved ? 'SOLVED' : 'FAILED'}
              </span>
            ) : (
              <span className={`header__player player-${currentPlayer}`}>
                {getPlayerDisplay()}
              </span>
            )}
          </>
        ) : (
          <>
            <span className="header__label">Move:</span>
            <span className={`header__player player-${currentPlayer}`}>
              {getPlayerDisplay()}
            </span>
          </>
        )}
        {onlineStatus && (
          <span className="header__player-tag">{onlineStatus.playerNum === 1 ? 'P1' : 'P2'}</span>
        )}
      </div>
      {onlineStatus && (
        <div className="header__online-status" style={onlineStatus.color ? { color: onlineStatus.color } : undefined}>
          {onlineStatus.text}
        </div>
      )}
      {showCastQuote && (
        <div className="header__cast-quote">
          you may cast the first stone
        </div>
      )}
    </header>
  );
};

export default Header;
